import { DocumentoTramite } from '../../shared/models/documento-tramite';
import { TipoAutenticacaoEnum } from '../../shared/enums/tipo-autenticacao.enum';
import { BaseState } from './base.state';
import { Injectable } from '@angular/core';

class DocumentoTramiteState extends BaseState<DocumentoTramite>{

}

export class AppState {

    documentoTramite? : DocumentoTramiteState;
    tipoAutenticacao? : TipoAutenticacaoEnum;
}
